import * as React from 'react';
import { ModuleProps } from 'src/utils/module-util';
import { CodeSplitVrboHotelWidgetMap } from './hotelWidget-map';

/**
 * Looks at the code-split Hero map and renders the desired ui component based on the name.
 */

export interface VrboWizardProps extends ModuleProps {
  wizardLocalization?: any;
  mccidData?: { 
    templateType?: string;
    campaignUrl?: string;
    mainUrl?: string;
    referrerId?: string;
  }; 
}

export const VrboHotelWidgetComponent = (props: VrboWizardProps) => {
  const component = CodeSplitVrboHotelWidgetMap;

  if (!component) {
    return null;
  }

  return React.createElement(component as any, props);
};
